import { createSelector } from "reselect"
import { getIsOpPro } from "modules/account-root/selectors"

export const getAnalyzeMenuItems = createSelector(
  [getIsOpPro],
  isOpPro => {
    return [
      { id: "performance", label: "Performance", order: 0 },
      {
        id: "risk",
        label: "Predictive Risk",
        order: 1,
        disabled: isOpPro,
        ...(isOpPro && { tooltip: "Only available with enterprise plan" }),
      },
    ]
  },
)
